type ManagementRolesKeys =
  | 'purchaseManager'
  | 'purchaseManagerAssistant'
  | 'postSalesManager'
  | 'postSalesManagerAssistant'
  | 'salesManager'
  | 'salesManagerAssistant';
export const ManagementRoleMapping: Record<ManagementRolesKeys, string> = {
  purchaseManager: 'Purchase Manager',
  purchaseManagerAssistant: 'Purchase Manager Assistant',
  postSalesManager: 'Post-Sales Manager',
  postSalesManagerAssistant: 'Post-Sales Manager Assistant',
  salesManager: 'Sales Manager',
  salesManagerAssistant: 'Sales Manager Assistant',
};

type ManagerModel = {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  files?: {
    AVATAR: string;
  };
};

export type { ManagerModel, ManagementRolesKeys };
